module.exports = __webpack_public_path__ + "static/media/youtube.0821e955.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/youtube.svg
// module id = 288
// module chunks = 0